export var isChannel = function (output) { return output.cid != null; };
